import Swiper, {
  Navigation,
  Pagination,
  Autoplay
} from 'swiper';

export class MvSwiper {
  constructor() {
    this.targetSwiper = document.querySelector('.c-mv-swiper')
    if (!this.targetSwiper) {
      return
    }
    this.el = this.targetSwiper.querySelector('.swiper')
    this.materDuration = 4000
    this.mater  = document.getElementById('js-mater')
    this.swiper = this._init()
  }

  _init() {
    return new Swiper(this.el, {
      modules: [Navigation, Pagination, Autoplay],
      loop: true,
      centeredSlides: true,
      speed: 1000,
      autoplay: false,
      pagination: {
        el: '.c-mv-swiper_num', // ページネーションとして認識させるクラス
        // clickable: true, // ページネーションをクリックしたら移動する
        // type: "fraction", //形のタイプ: bullets ドット型 | fraction 番号型 | custom カスタム
        type: 'custom',
        renderCustom: (mvSwiper, current, total) => {
          return (
            `<span class="_current">0&nbsp;${current}</span><span class="_total">0&nbsp;${total}</span>`
          )
        }    
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },  
      on: {
        slideChange: function() {
          /**
           - 1枚目のスライドはdelay:4000で切り替わりまで3秒。
           - 2枚目からは delay:4000 + speed:1000 で4秒掛かることになるので
           - 2枚目から delay:3000 に変更して4秒になるよう調整。
           */
          if (this.realIndex > 0) {
            this.params.autoplay.delay = 3000;//4000-300
            this.barDuration = 3000;
          }
        },
        slideChangeTransitionStart: (result) => {
          // スライド（次または前）へのアニメーションの開始時にイベント発生
          this.mater.style.transitionDuration = '0s'
          this.mater.style.transform = 'scaleX(0)'
        },
        slideChangeTransitionEnd: (result) => {
          // スライド（次または前）へのアニメーションの開始後にイベント発生
          this.mater.style.transitionDuration = this.materDuration + 'ms'
          this.mater.style.transform = 'scaleX(1)'
        },
      }
    })
  }

  start(options = {}) {
    options = Object.assign({
      delay: 4000,
      disableOnInteraction: false,
    }, options)

    this.swiper.params.autplay = options
    this.swiper.autoplay.start(options)
  }
  
  stop() {
    this.swiper.autoplay.stop()
  }
}
